import React, { useEffect, useState, useContext } from 'react';
import Backdrop from '@mui/material/Backdrop';
import {
  // ExternalCircle,
  MiddleCircle,
  InternalCircle,
  Center,
  LoadingText,
} from './CustomComponents/customComponentsForLoading';
import MainContext from '../../context/main/MainContext';

export default function SimpleBackdrop({ openState, text }) {
  const [open, setOpen] = useState(false);
  const { loading, loadingLabels } = useContext(MainContext);

  useEffect(() => {
    if (Object.values(loading).some((values) => values > 0)) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [loading]);

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 4801 }}
        open={openState || open}
      >
        {/* <ExternalCircle /> */}
        <MiddleCircle />
        <InternalCircle />
        <Center />
        <LoadingText>{text ? text : loadingLabels[0]}</LoadingText>
      </Backdrop>
    </>
  );
}
